export const PAGE_DEFAULT = 1;
export const PAGE_SIZE_DEFAULT = 20;
export const PAGE_SIZE_UNLIMITED = 9999999;

export const SCHOOL_YEAR_ACTIVE_ID = 10000; // this must match backend

export const BULK_SELECTED_ID_VALIDATION_PREFIX = "bulkSelectedID";
export const BULK_EDIT_UPDATE_EMPTY_WARNING =
  "Caution: A field that is toggled ON but left with EMPTY value will update to EMPTY for all selected items.";

export const CLOSE_WARNING = "There are unsaved changes. Click OK to close.";

export const BULK_DELETE_WARNING =
  "Are you sure you want to bulk delete the following items? You will not be able to undo this action. Press OK to continue";
export const DELETE_WARNING =
  "Are you sure you want to delete the follow item? You will not be able to undo this action. Press OK to continue";
export const REMOVE_WARNING = "Are you sure you want to remove the follow item? Press OK to continue";
export const BULK_LOCK_WARNING = "Are you sure you want to bulk lock the following items? Press OK to continue";
export const BULK_UNLOCK_WARNING = "Are you sure you want to bulk unlock the following items? Press OK to continue";
export const LOCK_WARNING =
  "You are attempting to lock an item. Once an item is locked, it cannot be edited in the future by users without sufficient permissions. Press OK to continue.";

export const CANNOT_DELETE_ITEM_IN_USE_MSG = "Cannot delete this item because it is in use.";

export type BooleanSelectListItem = {
  id: boolean;
  name: string;
};

export const BOOLEAN_SELECT_LIST_ITEMS: BooleanSelectListItem[] = [
  { id: true, name: "Yes" },
  { id: false, name: "No" },
];

export const FE_SEARCH_DELAY = 300;
export const SEARCH_DELAY = 500;
export const FE_LIST_FILTER_DEBOUNCE_DELAY_MS = 300;
